/* eslint-disable  @typescript-eslint/no-explicit-any */
export type ICallback = (...args: any[]) => void;

export class Debounce {
    protected resetTimeout: number;

    public debounce = (callback: ICallback, wait: number = 250) => {
        if (this.resetTimeout > 1) {
            return;
        }
        this.resetTimeout = window.setTimeout(() => {
            clearTimeout(this.resetTimeout);
            callback();
            this.resetTimeout = 0;
        }, wait);
    };
}
